import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";

export default function ServiceCard({ title, description, slug, category, icon: Icon, index = 0 }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ delay: index * 0.07, duration: 0.4 }}
      whileHover={{ y: -5 }}
      className="group bg-white rounded-2xl border border-gray-100 shadow-md hover:shadow-xl transition-all duration-200 p-6 flex flex-col h-full"
    >
      {Icon && (
        <div
          className="w-12 h-12 rounded-xl flex items-center justify-center mb-4 text-xl shrink-0 text-white"
          style={{ background: "var(--gradient-primary)" }}
        >
          <Icon />
        </div>
      )}
      {category && (
        <span className="text-xs font-semibold uppercase tracking-wider text-yellow-600 mb-2">
          {category}
        </span>
      )}
      <h3 className="font-bold text-lg lg:text-xl text-slate-800 mb-2 group-hover:text-blue-800 transition-colors leading-snug">
        {title}
      </h3>
      <p className="text-sm lg:text-base text-slate-500 leading-relaxed flex-1 mb-4">
        {description}
      </p>
      <Link
        to={`/services/${slug}`}
        className="inline-flex items-center gap-2 text-sm font-semibold text-blue-900 group-hover:gap-3 transition-all duration-200"
      >
        Learn More <FaArrowRight className="text-xs" />
      </Link>
    </motion.div>
  );
}
